module.exports = __webpack_public_path__ + "static/media/poster.5fc7f7d8.jpg";